import { Component, OnInit, Input } from '@angular/core';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { DatatableConfigurationMapperService } from '../../../analytics-core/services/datatable-configuration.mapper.service';
import { EVENT_EMITTERS, PATHS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { R10DevicesComponent } from '../r10-devices/r10-devices.component';
import * as _ from 'underscore';

@Component({
	selector: 'app-r10-conversions',
	templateUrl: './r10-conversions.component.html',
	styleUrls: ['./r10-conversions.component.css']
})
export class R10ConversionsComponent extends R10DevicesComponent implements OnInit {
	@Input() metricsarray: any;

	public tooltipOptions = {
		arrow: true
	};
	public metricsArray = [];
	public totalsArray = [];
	public metricObject;
	public dataLengthClass;
	responseData: any;
	groupByData: any;

	constructor(
		protected analyticsDataModel: AnalyticsDataModel,
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected dataTableService: DatatableConfigurationMapperService
	) {
		super(analyticsDataModel, analyticsService, colorUtilityService, dataTableService);
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngOnInit(): void {
		super.ngOnInit();
		this.metricsArray = JSON.parse(decodeURI(this.metricsarray));
		if (this.metricsArray) {
			this.metricsArray = _.filter(this.metricsArray, (item) => {
				return this.analyticsDataModel.checkComponentForPermission(item);
			});
		}
	}

	processDeviceColor(responseData: any): void {
		const colorArray = [
			this.colorPalette.primaryColor,
			this.colorPalette.secondaryColor,
			this.colorPalette.tertiaryColor,
			this.colorPalette.quaternaryColor,
			this.colorPalette.quinaryColor
		];
		for (let j = 0; j < this.multichartconfigurations.length; ++j) {
			this.multichartconfigurations[j].chartConfig.series[0].colors = colorArray
				.slice(0, responseData.length)
				.reverse();
		}
		this.deviceCount = 'device-' + responseData.length;
	}

	processResponseData(responseData: any): void {
		this.processDeviceColor(responseData);
		for (const metric of this.metricsArray) {
			if (metric) {
				const sum_conversions = responseData.reduce((s, f) => s + Number(f[metric.valueKey]), 0);
				const all_conv_sum = responseData.reduce((s, f) => s + Number(f['all_conversions']), 0);
				this.totalsArray['conversions'] = sum_conversions;
				this.totalsArray['all_conversions'] = all_conv_sum;
				this.totalsArray['conversion_rate'] = ((sum_conversions / parseInt(responseData[0].clicks)) * 100).toFixed(2);
			}
		}

		this.metricObject = [
			{
				name: 'Conversions',
				value: this.totalsArray['conversions'].toLocaleString(),
				tooltip:
					'An action that’s counted when someone interacts with your ad or free product listing, then takes an action you’ve defined as valuable to your business, such as a purchase or a phone call.'
			},
			{
				name: 'Conversion Rate',
				value: this.totalsArray['conversion_rate'] + '%',
				tooltip: 'The average number of conversions per ad interaction, as a percentage.'
			},
			{
				name: 'All Conversions',
				value: this.totalsArray['all_conversions'].toLocaleString(),
				tooltip:
					'A calculation of all the conversions that Google Ads drives for your business, including any actions being excluded from your tracking metrics.'
			}
		];
		responseData = this.conversionsDataProcess(responseData).reverse();
		this.dataLengthClass = 'data-length-' + responseData.length;
		this.multichartconfigurations[0].chartConfig.xAxis[0].labels.formatter =
			this.getXaxisToolTipFormatter(responseData);
		this.devicesChartData = responseData;
		this.deviceLegendData = [];
		for (const responseObj of responseData) {
			let resultObj: object = {};
			this.multidatatableconfigurations.forEach((datatableConfig) => {
				resultObj = {
					...{},
					...resultObj,
					...this.dataTableService.generateDatatableSourceDataFromConfig(responseObj, datatableConfig.columns)
				};
			});
			this.deviceLegendData.push(resultObj);
		}
		this.deviceLegendData = this.deviceLegendData.reverse();
	}

	getXaxisToolTipFormatter(data): any {
		return function (): string {
			let index = this.axis.categories.indexOf(this.value);
			let text = data[index].tooltip
				? `<div class="sem-tooltip">
        <span>${data[index].tooltip}</span>
        <span class="sem-arrow"></span>
    </div>`
				: '';
			return (
				`<span aria-label="${data[index].tooltip}" class="sem-legend" >
                    <span class="sem-legendname">${this.value}</span>` +
				text +
				`</span>`
			);
		};
	}

	conversionsDataProcess(responseData: any) {
		if (responseData?.length <= 5) {
			responseData = responseData;
		} else {
			let tempAllConversions = 0;
			let tempCoversions = 0;
			let tempclicks = 0;

			for (let i = 4; i < responseData?.length; i++) {
				tempAllConversions += Number(responseData[i]['all_conversions']);
				tempCoversions += Number(responseData[i]['conversions']);
				tempclicks = Number(responseData[i]['clicks']);
			}
			let tempDataArray = {
				all_conversions: tempAllConversions.toString(),
				conversion_action: 'Additional',
				conversions: tempCoversions.toString(),
				clicks: tempclicks.toString(),
				tooltip: 'All other conversion actions.'
			};
			let updatedRespData = responseData.splice(0, 4);
			updatedRespData.splice(4, 0, tempDataArray);
			responseData = updatedRespData;
			this.responseData = responseData;
		}
		this.groupByData = responseData.filter((obj) => {
			return obj['conversions'] != 0 || obj['all_conversions'] != 0;
		});
		return this.groupByData;
	}
}
